<template>
	<div>
		<span class="text-danger" v-if="!value || !value.length">{{ emptyMesssage }}</span>
		<div>
			<div v-for="(item, index) in value" :key="'coordinator'+item.userId" class="coordinators-item py-2 px-1">
				<span>{{index+1}}.</span>
				&nbsp;{{item.name}}
				<!-- <span class="text-danger fa fa-trash float-right pointer" :title="$t('remove')" @click="remove(item)"></span> -->
			</div>
		</div>
		<div v-if="!removeAddBtn">
			<button class="btn btn-primary text-primary m-0" v-if="!showAdd" @click="toggleAddInput">
				<i class="fa fa-plus"></i>
				{{$t('add')}}
			</button>
			<SearchBox
                ref="searchbox"
                v-if="showAdd"
                :apiUrl="apiUrl"
                :showAllUsersBtn="showAllUsersBtn"
                @input="onNewPersonInput"
            />
		</div>
	</div>
</template>

<script>
import SearchBox from '@/components/common/SearchBox';

export default {
	components: {
		SearchBox
	},
	props: {
		value: Array,
        removeAddBtn: {
            type: Boolean,
            default: false
        },
        emptyMesssage: {
            type: String,
            default() {
                return this.$t('coordinations.noCoordinatorsMsg');
            }
        },
        apiUrl: {
            type: String,
            default() {
                return 'api/user/search'
            }
        },
        showAllUsersBtn: {
            type: Boolean,
            default() {
                return false;
            }
        }
	},
	data() {
		return {
			showAdd: false
		};
	},
	methods: {
		add(item) {
			this.value.push(item);
		},
		remove(item) {
			const index = this.value.indexOf(item);
			this.value.splice(index, 1);
		},
		toggleAddInput() {
			this.showAdd = !this.showAdd;
		},
		onNewPersonInput(userId, text) {
			if (!this.value.some(x => x.userId === userId)) {
				this.add({ userId, name: text });
				this.toggleAddInput();
				this.checkUserAvailability(userId);
			}
		},
		checkUserAvailability(userId) {
			this.$http
				.get('/api/presenceForm/checkuser?ids=' + userId)
				.then(result => {
					console.log('Users check: ', result.data);
					if (result.data && result.data.length) {
						if (result.data[0].replacementUserId) {
							this.offerReplacement(userId, result.data[0]);
						} else {
							this.offerNoReplacement(userId);
						}
					}
				})
				.catch(err => console.log(err));
		},
		offerReplacement(userId, replacement) {
			var index = this.value.findIndex(x => x.userId === userId);

			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: this.$t('notifications.warning'),
				text: this.$t('tasks.switchWithReplacement').format(this.value[index].name, replacement.replacementName),
				accept: () => {
					if (!this.value.some(x => x.userId === replacement.replacementUserId)) {
						this.$set(this.value, index, { userId: replacement.replacementUserId, name: replacement.replacementName });
					} else {
						// Replacement is already in the list, so we just delete the added user
						this.value.splice(index, 1);
					}
				},
				acceptText: this.$t('buttons.ok'),
				cancelText: this.$t('buttons.cancel'),
				cancel: () => {}
			});
		},
		offerNoReplacement(userId) {
			var index = this.value.findIndex(x => x.userId === userId);

			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: this.$t('notifications.warning'),
				text: this.$t('tasks.switchNoReplacement').format(this.value[index].name),
				accept: () => {
					this.value.splice(index, 1);
				},
				acceptText: this.$t('buttons.ok'),
				cancelText: this.$t('buttons.cancel'),
				cancel: () => {}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.coordinators-item {
	&:hover {
		background-color: lightgrey;
	}
	border-left: 2px solid #009688cc;
}
</style>
